import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "placeholder", "disabled", "maxlength", "id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("input", {
    type: "text",
    value: _ctx.displayValue,
    onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateValue && _ctx.updateValue(...args))),
    class: _normalizeClass(_ctx.allClasses),
    onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectOnFocus($event))),
    placeholder: _ctx.placeholder,
    disabled: _ctx.isDisabled,
    autocomplete: "off",
    maxlength: _ctx.maxlength,
    id: _ctx.id,
    onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.inputChange && _ctx.inputChange(...args)))
  }, null, 42, _hoisted_1))
}